// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + ".min.js?v=2026-01-20-201142-4c99910-001323";
};